const moduloGaritas = {
  agGrid: {
    paginacion: 15,
    id: 'myGridListGaritas',
    class: 'ag-theme-alpine',
    style: {
      width: '100%',
      height: '600px'
    }
  },
  titulos: {
    mantenimientoGaritas: {
      titulo: 'Mantenimiento de Garitas',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Garitas',
      tituloAgregar: 'Agregar Garita',
      tituloActualizar: 'Actualizar Garita'
    },
    relacionUsuarioGaritas: {
      titulo: 'Relación Usuario Garitas',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Relación Usuario Garitas',
      tituloAgregar: 'Agregar Relacion Usuario Garita',
      tituloActualizar: 'Actualizar Relacion Usuario Garita'
    },
    ticketAutorizacionTransporte: {
      titulo: 'Ticket Autorización Garita',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ticket Autorización Transporte',
      tituloAgregar: 'Agregar Ticket',
      tituloActualizar: 'Actualizar Ticket de Garita',
    },
    ordenesReferenciaCompra: {
      titulo: 'Órdenes de Referencia de Maquila',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Órdenes de Referencia de Maquila',
      tituloAgregar: 'Agregar Orden',
      tituloActualizar: 'Actualizar Orden'
    },
    mantenimientoBascula: {
      titulo: 'Mantenimiento Báscula',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Mantenimiento Báscula',
      tituloAgregar: 'Agregar Bascula',
      tituloActualizar: 'Actualizar Bascula'
    },
    relacionUsuarioBascula: {
      titulo: 'Realación Usuario Báscula',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Realación Usuario Báscula',
      tituloAgregar: 'Agregar Usuario Bascula',
      tituloActualizar: 'Actualizar Usuario Bascula'
    },
    tipoOrdenesBalanza: {
      titulo: 'Tipo Ordenes de Balanza',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Tipo Ordenes de Balanza',
      tituloAgregar: 'Agregar Orden',
      tituloActualizar: 'Actualizar Orden'
    },
    parametroFactorConversion: {
      titulo: 'Parametro de Factor Conversion API',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Parametro de Factor Conversion API',
      tituloAgregar: 'Agregar Factor conversion API',
      tituloActualizar: 'Actualizar Factor conversion API'
    },
    ordenesDeBalanza: {
      titulo: 'Ordenes de Balanza',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ordenes de Balanza',
      tituloAgregar: 'Agregar Ordenes de Balanza',
      tituloActualizar: 'Actualizar Ordenes de Balanza'
    },
    ordenesDeBalanzaSalida: {
      titulo: 'Ordenes de Balanza - Captura de Peso Salida',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ordenes de Balanza - Captura de Peso Salida',
      tituloAgregar: 'Agregar Ordenes de Balanza - Captura de Peso Salida',
      tituloActualizar: 'Actualizar Ordenes de Balanza - Captura de Peso Salida'
    },
    notificaciones: {
      titulo: 'Notificaciones',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Notificaciones',
      tituloAgregar: 'Agregar Notificación',
      tituloActualizar: 'Actualizar Notificación'
    },
    parametrizarValorFlete: {
      titulo: 'Valor de Flete',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Valor de Flete',
      tituloAgregar: 'Agregar Valor de Flete',
      tituloActualizar: 'Actualizar Valor de Flete'
    },
    desbloqueoOrdenBalanza: {
      titulo: 'Desbloqueo Orden de Balanza',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Desbloqueo Orden de Balanza',
      tituloAgregar: 'Agregar Desbloqueo Orden de Balanza',
      tituloActualizar: 'Actualizar Desbloqueo Orden de Balanza'
    },
    desbloqueoOrdenBalanzaCalidad: {
      titulo: 'Desbloqueo Orden de Balanza - Calidad',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Desbloqueo Orden de Balanza - Calidad',
      tituloAgregar: 'Agregar Desbloqueo Orden de Balanza - Calidad',
      tituloActualizar: 'Actualizar Desbloqueo Orden de Balanza - Calidad'
    },
    mantMermaAsigClient: {
      titulo: 'Porcentaje de Merma y Asignación Cliente - Calidad',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Porcentaje de Merma y Asignación Cliente - Calidad',
      tituloAgregar: 'Agregar Porcentaje de Merma y Asignación Cliente - Calidad',
      tituloActualizar: 'Actualizar Porcentaje de Merma y Asignación Cliente - Calidad'
    },
    mantUsuarioBasculaGarita: {
      titulo: 'Usuario Báscula y Garita',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Usuario Báscula y Garita',
      tituloAgregar: 'Agregar Usuario Báscula y Garita',
      tituloActualizar: 'Actualizar Usuario Báscula y Garita'
    },
    porcentajeToleranciaNivelesPeso: {
      titulo: 'Porcentaje Toleracia de Niveles de Peso',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Porcentaje Toleracia de Niveles de Peso',
      tituloAgregar: 'Agregar Porcentaje Toleracia de Niveles de Peso',
      tituloActualizar: 'Actualizar Porcentaje Toleracia de Niveles de Peso'
    },
    notaMaquila: {
      titulo: 'Nota Maquila',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Nota Maquila',
      tituloAgregar: 'Agregar Nota Maquila',
      tituloActualizar: 'Actualizar Nota Maquila'
    },
    usuariosAprobadores: {
      titulo: 'Administración de Usuarios Aprobadores',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Mantenimiento de Usuarios Aprobadores',
      tituloAgregar: 'Mantenimiento de Usuarios Aprobadores',
      tituloActualizar: 'Actualizar Mantenimiento de Usuarios Aprobadores'
    },
    configuracionMotivosDeDesbloqueos: {
      titulo: 'Listado de Motivos de Anulación/Desbloqueos Planificación y Balanza',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Motivos de Anulación/Desbloqueos Ordenes de Balanza',
      tituloAgregar: 'Motivos de Anulación/Desbloqueos Ordenes de Balanza',
      tituloActualizar: 'Actualizar Motivos de Anulación/Desbloqueos Ordenes de Balanza'
    },
    parametrizacionesDeCalidadRecibida: {
      titulo: 'Listado de Parametrizaciones de Calidad Recibida | Premios y Castigos',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Parametrizaciones de Calidad Recibida | Premios y Castigos',
      tituloAgregar: 'Parametrizaciones de Calidad Recibida | Premios y Castigos',
      tituloActualizar: 'Actualizar Parametrizaciones de Calidad Recibida | Premios y Castigos'
    },
    parametrizacionesDeFactoresConversion: {
      titulo: 'Listado de Parametrizaciones de Factores Conversión | Premios y Castigos',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Parametrizaciones de Factores Conversión | Premios y Castigos',
      tituloAgregar: 'Parametrizaciones de Factores Conversión | Premios y Castigos',
      tituloActualizar: 'Actualizar Parametrizaciones de Factores Conversión | Premios y Castigos'
    },
    mantenimientoOrigenesExtractoras: {
      titulo: 'Listado de Mantenimiento Origenes Extractoras',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Mantenimiento Origenes Extractoras',
      tituloAgregar: 'Mantenimiento Origenes Extractoras',
      tituloActualizar: 'Actualizar Mantenimiento Origenes Extractoras'
    },
    kardex: {
      titulo: 'KARDEX para cálculo de Premios y castigos',
      modulo: 'Balanza',
      tituloCardListar: 'Listar KARDEX para cálculo de Premios y castigos',
      tituloAgregar: 'KARDEX para cálculo de Premios y castigos',
      tituloActualizar: 'Actualizar KARDEX para cálculo de Premios y castigos'
    },
    reporteria: {
      titulo: 'Reporte de Balanza por Tipo de Ordenes',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Reporte de Balanza por Tipo de Ordenes',
      tituloAgregar: 'Reporte de Balanza por Tipo de Ordenes',
      tituloActualizar: 'Actualizar Reporte de Balanza por Tipo de Ordenes'
    },
    reporteCompras: {
      titulo: 'Reporte de Balanza Compras',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Reporte de Balanza por Tipo de Ordenes',
      tituloAgregar: 'Reporte de Balanza por Tipo de Ordenes',
      tituloActualizar: 'Actualizar Reporte de Balanza por Tipo de Ordenes'
    },
    mantenerTanqueros: {
      titulo: 'Mantenimiento de Tanqueros',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Tanqueros',
      tituloAgregar: 'Agregar Tanquero',
      tituloActualizar: 'Actualizar Tanquero',
    },
    mantenerDobi: {
      titulo: 'Mantenimiento de Tipo de calidad Dobi',
      modulo: 'Balanza',
      tituloCardListar: 'Listar rangos de calidad dobi',
      tituloAgregar: 'Agregar registro',
      tituloActualizar: 'Actualizar registro',
    },
    ordenesCerradas: {
      titulo: 'Ordenes Cerradas',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ordenes',
      tituloAgregar: '',
      tituloActualizar: '',
    },
    ordenesActualizarEstado: {
      titulo: 'Ordenes actualizar estado',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ordenes',
      tituloAgregar: '',
      tituloActualizar: '',
    },
    ordenesReasignación: {
      titulo: 'Ordenes reasignar bascula',
      modulo: 'Balanza',
      tituloCardListar: 'Listar Ordenes',
      tituloAgregar: '',
      tituloActualizar: '',
    }
  },
  button: {
    buttonsCss: {
      danger: 'btn btn-danger btn-block',
      info: 'btn btn-info btn-block',
      warning: 'btn btn-warning btn-block'
    },
    buttonsNombre: {
      //*GLOBAL
      editar: 'Editar',
      eliminar: 'Eliminar',
      nuevo: 'Nuevo',
      agregar: 'Agregar',
      imprimir: 'Imprimir',

      agregarGarita: 'Agregar Garita',
      agregarRelacionGarita: 'Agregar Relación',
      agregarTicketAutorizacionTransporte: 'Agregar Ticket'
    }
  },
  mensajes: {
    eliminar: '¿Esta seguro que desea eliminar el siguiente registro?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente registro?',
    datoGuardado: 'Se guardo corectamente..!!',
    completeInformacion: 'Complete la informacion requerida',
    mensajeAdvertencia: 'La Órden contiene un solo elemento en el detalle desea eliminar la órden completa?',
    guardarDatorForm: 'Desea guardar los datos del formulario',
    mjsProcesar: 'Desea procesar los datos del formulario',
    mjsCampo: 'Al menos debe contener otro Campo "Articulo Alternativo"',
    mjsCampo1: 'Al menos debe contener otro Campo "CodigoBarra"',
    mjsCampo2: 'Al menos debe contener otro Campo',
    mjsCampoAdv: 'Obligatorio Campo Cantidad',
    mjsFilasCorrectas: 'Filas Correctas',
    mjsFilasIncorrectas: 'Filas Incorrectas',
    procesar: '¿Esta seguro que desea procesar el siguiente formulario?'
  },
  url: {
    mantenimientoGaritas: {
      obtenerTodo: 'mantenimiento-garita',
      obtenerPorId: 'mantenimiento-garita/',
      crear: 'mantenimiento-garita/crear',
      actualizar: 'mantenimiento-garita/actualizar',
      eliminar: 'mantenimiento-garita/borrar?idMantGari='
    },
    relacionUsuarioGaritas: {
      obtenerTodo: 'rel-garitas',
      obtenerPorId: 'rel-garitas/',
      crear: 'rel-garitas/crear',
      actualizar: 'rel-garitas/actualizar',
      eliminar: 'rel-garitas/borrar?idRGari='
    },
    ticketAutorizacionTransporte: {
      obtenerTodo: 'mantenimiento-ticket-transporte',
      obtenerPorId: 'mantenimiento-ticket-transporte/',
      crear: 'mantenimiento-ticket-transporte/crear',
      actualizar: 'mantenimiento-ticket-transporte/actualizar',
      eliminar: 'mantenimiento-ticket-transporte/borrar?idTicket=',
      imprimir: 'mantenimiento-ticket-transporte/generardocumento',
      getCliente: 'cliente/',
      controlDuplicidad: 'mantenimiento-ticket-transporte/ticketxorden/',
      getFiltros: 'mantenimiento-ticket-transporte/estado/',
    },
    ordenesRefMaq: {
      obtenerTodo: 'ordenes-referencia-maquila',
      obtenerPorId: 'ordenes-referencia-maquila/buscarporId?idOrdRefMaq=',
      crear: 'ordenes-referencia-maquila/crear',
      actualizar: 'ordenes-referencia-maquila/actualizar',
      eliminar: 'ordenes-referencia-maquila/borrar?idOrdRefMaq='
    },
    mantBascula: {
      obtenerTodo: 'mantenimiento-bascula',
      obtenerPorId: 'mantenimiento-bascula/buscarporId?idMantBasc=',
      crear: 'mantenimiento-bascula/crear',
      actualizar: 'mantenimiento-bascula/actualizar',
      eliminar: 'mantenimiento-bascula/borrar?idMantBasc=',
      centros: 'centro-logistico'
    },
    relUsuarioBascula: {
      obtenerTodo: 'mantenimiento-usuario-bascula',
      obtenerPorId: 'mantenimiento-usuario-bascula/buscarporId?idMantUsr=',
      crear: 'mantenimiento-usuario-bascula/crear',
      actualizar: 'mantenimiento-usuario-bascula/actualizar',
      eliminar: 'mantenimiento-usuario-bascula/borrar?idManUsr='
    },
    tipoOrdenBalanza: {
      obtenerTodo: 'tipo-orden-balanza',
      obtenerPorId: 'tipo-orden-balanza/buscarporId?id=',
      crear: 'tipo-orden-balanza/crear',
      actualizar: 'tipo-orden-balanza/actualizar',
      eliminar: 'tipo-orden-balanza/borrar?idMantUsr='
    },
    paramFacConver: {
      obtenerTodo: 'factor-de-coversion',
      obtenerPorId: 'factor-de-coversion/buscarporId?idFact=',
      crear: 'factor-de-coversion/crear',
      actualizar: 'factor-de-coversion/actualizar',
      eliminar: 'factor-de-coversion/borrar?idFact='
    },
    ordenesBalanza: {
      obtenerTodo: 'ordenes-balanza',
      obtenerPorId: 'ordenes-balanza/buscarporId?idBalanza=',
      crear: 'ordenes-balanza/crear',
      actualizar: 'ordenes-balanza/actualizar',
      eliminar: 'ordenes-balanza/borrar?idBalanza=',
      imprimirEntrada: 'ordenes-balanza/generardocumento',
      imprimirSalida: 'ordenes-balanza/generardocumentosalida',
      buscarFleteSap: 'ordenes-balanza/buscarFleteSap/',
      pesoSalida: 'ordenes-balanza/actualizar',
      buscarPorEstado: 'ordenes-balanza/buscarPorEstado?estado=',
      buscarDesbloqueos: 'ordenes-balanza/buscarPorEstBloqueado?',
      buscarOC: 'balanza/orden-compra/codOrdenCompra/',
      reporte: 'reporte?',
      reporteria: 'ordenes-balanza/reporte',
      cerrarOrden: 'ordenes-balanza/cerrar-orden',
      validacionMDI: 'MDI/mdiConsumo',
      pesoBalanza: 'toledo/balanza/',
      imprimirEtiqueta: 'ordenes-balanza/generarticketimprimir?idOrden=',
      pesoBalanzaUser: 'toledo/balanza-user/',
      actualizarEstado: "ordenes-balanza/actualizar-estado",
      reasignarBascula: "ordenes-balanza/reasignar-bascula",
      actualizarDatosBasicos: "ordenes-balanza/actualizar-datosbasicos",
      filtrarOrdenesCerradas: 'ordenes-balanza/cerradas/',
      filtrarOrdenesBloqueadas: 'bloqueo-balanza/filtros?',
    },
    notificaciones: {
      obtenerTodo: 'notificaciones',
      obtenerPorId: 'notificaciones/',
      crear: 'notificaciones/crear',
      actualizar: 'notificaciones/actualizar',
      eliminar: 'notificaciones/borrar?idMantGari='
    },
    parametrizarValorFlete: {
      obtenerTodo: 'mant-valor-flete',
      obtenerPorId: 'valor-flete/',
      crear: 'mant-valor-flete/crear',
      actualizar: 'mant-valor-flete/actualizar',
      eliminar: 'mant-valor-flete/borrar?id=',
      getProveedor: 'proveedorRest/findByRuc/',
      getMaterial: 'material/',
      getAlmacen: 'almacen/',
      obtenerProveedrorMaterial: 'mant-valor-flete/buscarporProveedorMaterial?',
    },
    desbloqueoOrdenBalanza: {
      obtenerTodo: 'bloqueo-balanza/getPeso',
      crear: 'bloqueo-balanza/crearPeso',
      buscarDesbloqueos: 'ordenes-balanza/desbloqueo',
      desbloqueo: 'ordenes-balanza/desbloquear',
    },
    desbloqueoOrdenBalanzaCalidad: {
      obtenerTodo: 'bloqueo-balanza/getCalidad',
      crear: 'bloqueo-balanza/crearCalidad',
    },
    mantMermaAsigClient: {
      obtenerTodo: 'mantenimiento-merma-cliente',
      crear: 'mantenimiento-merma-cliente/crear',
      actualizar: 'mantenimiento-merma-cliente/actualizar'
    },
    mantUsuarioBasculaGarita: {
      obtenerTodo: 'usuario-bascula',
      crear: 'usuario-bascula/crear',
      actualizar: 'usuario-bascula/actualizar',
      eliminar: 'usuario-bascula/borrar?id=',
      buscarporUsuario: 'usuario-bascula/buscarporUsuario?usuario=',
      buscarporId: 'usuario-bascula/buscarporId?usuario='
    },
    porcentajeToleranciaNivelesPeso: {
      obtenerTodo: 'matn-porc-peso',
      crear: 'matn-porc-peso/crear',
      actualizar: 'matn-porc-peso/actualizar',
      eliminar: 'matn-porc-peso/borrar?id=',
      getMaterial: 'material/',
    },
    material: {
      obtenerPorId: 'material/'
    },
    cliente: {
      obtenerPorId: 'cliente/'
    },
    usuarios: {
      obtenerTodo: 'usuario-rest',
      obtenerPorId: 'usuario-rest/'
    },
    notaMaquila: {
      obtenerTodo: 'toledo',
      obtenerPorId: 'toledo/reporte-maquila/',
      imprimir: 'ordenes-balanza/generardocumentoMaquila?idOrden=',
    },
    proveedor: {
      obtenerPorRuc: 'proveedor/ruc/',
      obtenerPorId: 'proveedor/'
    },
    placaTransportista: {
      obtenerPorCedula: 'placaRest/findByCedula/',
      obtenerPorId: 'placaRest/findById/',
      obtenerPorPlaca: 'placa/'
    },
    cedulaChofer: {
      obtenerPorCedula: 'chofer/cedula/',
      obtenerPorId: 'choferRest/findById/'
    },
    almacen: {
      obtenerTodo: 'almacenRest'
    },
    ordenesCompra: {
      obtenerTodo: 'ordenes-compra',
      obtenerPorId: 'ordenes-compra/buscarporId?idCompra=',
      obtenerCantidadBase: 'detalle-solped/RegistroInfo/',
    },
    centros: {
      obtenerTodo: 'centro-logistico'
    },
    usuariosAprobadores: {
      obtenerTodo: 'mantenimiento-usuario-aprobador',
      obtenerPorId: 'mantenimiento-usuario-aprobador/',
      crear: 'mantenimiento-usuario-aprobador/crear',
      actualizar: 'mantenimiento-usuario-aprobador/actualizar',
      eliminar: 'mantenimiento-usuario-aprobador/borrar?idmantUserAprobador=',
    },
    parametrizacionesDeCalidadRecibida: {
      obtenerTodo: 'mantenimiento-parametro-calidad',
      obtenerPorId: 'mantenimiento-parametro-calidad/buscarporId?id=',
      crear: 'mantenimiento-parametro-calidad/crear',
      actualizar: 'mantenimiento-parametro-calidad/actualizar',
      eliminar: 'mantenimiento-parametro-calidad/borrar?id=',
    },
    parametrizacionesDeFactoresConversion: {
      obtenerTodo: 'mantenimiento-factor-conversion-premio-castigo',
      obtenerPorId: 'mantenimiento-factor-conversion-premio-castigo/buscarporId?id=',
      crear: 'mantenimiento-factor-conversion-premio-castigo/crear',
      actualizar: 'mantenimiento-factor-conversion-premio-castigo/actualizar',
      eliminar: 'mantenimiento-factor-conversion-premio-castigo/borrar?id=',
    },
    mantenimientoOrigenesExtractoras: {
      obtenerTodo: 'mantenimiento-origenes-extractoras',
      obtenerPorId: 'mantenimiento-origenes-extractoras/buscarporId?id=',
      crear: 'mantenimiento-origenes-extractoras/crear',
      actualizar: 'mantenimiento-origenes-extractoras/actualizar',
      eliminar: 'mantenimiento-origenes-extractoras/borrar?idOrigenExtractora=',
    },
    configuracionMotivosDeDesbloqueos: {
      obtenerTodo: 'mantenimiento-motivo-balanza',
      obtenerPorId: 'mantenimiento-motivo-balanza/buscarporId?id=',
      crear: 'mantenimiento-motivo-balanza/crear',
      actualizar: 'mantenimiento-motivo-balanza/actualizar',
      eliminar: 'mantenimiento-motivo-balanza/borrar?id=',
    },
    kardex: {
      obtener: 'permios-castigo?idProveedor=',
      obtenerPorProveedor: 'permios-castigo?idProveedor=',
      obtenerTodos: 'mantenimiento-premio-castigo',
    },
    tanqueros: {
      obtenerTodo: 'mantenimiento-tanqueros',
      obtenerPorId: 'mantenimiento-tanqueros/',
      crear: 'mantenimiento-tanqueros/crear',
      actualizar: 'mantenimiento-tanqueros/actualizar',
      eliminar  : 'mantenimiento-tanqueros/borrar?idTanquero=',
    },
    dobi: {
      obtenerTodo: 'mantenimiento-dobi',
      obtenerPorId: 'mantenimiento-dobi/',
      crear: 'mantenimiento-dobi/crear',
      actualizar: 'mantenimiento-dobi/actualizar',
      eliminar  : 'mantenimiento-dobi/eliminar',
    },
  }
}

export {moduloGaritas}
